<template>
    <el-dialog append-to-body width="500px" :title="title" :visible.sync="visible" :before-close="handleClose">
        <div class="modal-body">
            <div class="content flex-xy-center">
                {{ content }}
            </div>
            <div class="btn" @click="handleClose">我知道了</div>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: 'Dialog',
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            default: '提示'
        },
        content: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            loading: false,
        }
    },
    watch: {
        visible(value) {

        }
    },
    methods: {
        // 关闭窗口
        handleClose() {
            // 更新visible参数
            this.$emit('update:visible', false)
        }
    }
}
</script>
<style lang="scss" scoped>
.modal-body {

    .content {
        font-size: 16px;
        color: #343A40;
        line-height: 28px;
        width: 100%;
        padding: 10px 16px;
        max-height: 500px;
    }

    .btn {
        padding: 10px 50px;
        font-size: 20px;
        color: #FFFFFF;
        background: #00B4E8;
        border-radius: 25px;
        margin: 30px auto 0 auto;
        width: fit-content;
        cursor: pointer;
    }
}
</style>